import { Avatar } from "@circleco/compass/components/Avatar";
import { iconButtonVariants } from "@circleco/compass/components/IconButton";
import { forwardRef, type ComponentPropsWithoutRef } from "react";

interface AvatarButtonProps extends Omit<
  ComponentPropsWithoutRef<"button">,
  "children"
> {
  ariaLabel: string;
  "data-testid"?: string;
  isOpen?: boolean;
  name?: string;
  src?: string;
}

export const AvatarButton = forwardRef<HTMLButtonElement, AvatarButtonProps>(
  (
    {
      ariaLabel,
      src,
      name,
      isOpen = false,
      disabled = false,
      "data-testid": dataTestId,
      ...props
    },
    ref,
  ) => (
    <button
      ref={ref}
      type="button"
      className={iconButtonVariants({ variant: "ghost", size: "sm" })}
      aria-label={ariaLabel}
      data-testid={dataTestId}
      data-popup-open={isOpen || undefined}
      disabled={disabled}
      {...props}
    >
      <Avatar src={src} name={name} size="sm" decorative />
    </button>
  ),
);

AvatarButton.displayName = "AvatarButton";
